import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseProvider } from '../BaseProvider';
import { LoginResponseModel, CompanyProfileModel, CompanyProfileUpdateModel } from '../../_models/index';
import { GlobalService } from '../../_global/global.service';

@Injectable()
export class CompanyService extends BaseProvider {

    // resource = 'partners/' + this._gs.currentUser.partner.id;
    resource = 'partners/';
    constructor(private http: Http, private _gs: GlobalService) {
        super(http);
        if (this._gs.currentUser) {
            this.resource = this.resource + this._gs.currentUser.partner.id;
        }
    }

    getCompanyDetails() { // Fetch a particular partner details given the id
        return this.makeGetCall(this.resource);
    }
    getKYCDocs(urlParam) {
        return this.makeGetCall('doclocker/kycDocumentList?' + urlParam);
    }
    getuploadedDocs(partnerId) {
        return this.makeGetCall('doclocker/documents/' + partnerId);
    }
    updateCompany(companyProfileUpdate: CompanyProfileUpdateModel) { // Update an partner profile given the updated profile details
        return this.makePutCall(this.resource, companyProfileUpdate);
    }
    updateCompanyPatch(companyProfileUpdate: CompanyProfileUpdateModel) { // Update an partner profile given the updated profile details
        return this.makePatchCall(this.resource, companyProfileUpdate);
    }
    uploadCompanyPhoto(uploadRequest: any) { // Update an user Document
        return this.makeUploadCallPost(this.resource + '/photo', uploadRequest);
    }

    uploadCompanyLogo(uploadRequest: any) { // Update an user Document
        return this.makeUploadCallPost(this.resource + '/logo', uploadRequest);
    }

    deleteDocument(documentId: any) {
        return this.makeDeleteCall('doclocker/documents/' + documentId);
    }
    uploadDocuments(imageData: any) {
        return this.makeUploadCall('doclocker/documents', imageData);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/profile/company.service.ts